// extracted by mini-css-extract-plugin
module.exports = {"mask":"wxQrCode_mask__2cu2N","content":"wxQrCode_content__1xAZW","tip":"wxQrCode_tip__30RFi","qrCode":"wxQrCode_qrCode__GV0ga","close":"wxQrCode_close__2Zmak"};